export function validPathname(pathname: string) {
  return pathname == ''
    ? null
    : /^[a-z0-9-]*$/.test(pathname)
    ? null
    : 'В url могут быть только цифры, английские прописные буквы и тире'
}
